import { useState } from "react";
import { toast } from "sonner";
import { CalendarPlus } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export const nextMonth = () => { const d = new Date(); d.setDate(1); d.setMonth(d.getMonth() + 1); return d.toISOString().slice(0, 7); };
export const monthLabel = (m) => (m ? new Date(`${m}-15`).toLocaleDateString("en-AU", { month: "short", year: "numeric" }) : "");

export const AddToPlan = ({ r, countries, onAdded }) => {
  const [month, setMonth] = useState(nextMonth());
  const [country, setCountry] = useState("Italy");
  const [busy, setBusy] = useState(false);
  const tid = r.town.toLowerCase().replace(/\W+/g, "-");
  if (r.status === "planned") return <span className="text-xs text-[#2D6A4F]" data-testid={`insights-planned-${tid}`}>Planned · {monthLabel(r.plan_month)}</span>;
  if (r.status === "live" || r.status === "built") return null;
  const add = async () => {
    setBusy(true);
    try {
      await api.post("/plan/items", { town: r.town, month, ...(r.status === "new" ? { country } : {}) });
      toast.success(`${r.town} added to the ${monthLabel(month)} build plan`);
      onAdded();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <span className="flex items-center gap-1.5">
      {r.status === "new" && (
        <select value={country} onChange={(e) => setCountry(e.target.value)} data-testid={`insights-country-${tid}`} className="text-xs border border-[#E2D9CC] px-1 py-1 bg-white">
          {countries.map((c) => <option key={c}>{c}</option>)}
        </select>)}
      <input type="month" value={month} onChange={(e) => setMonth(e.target.value)} data-testid={`insights-month-${tid}`} className="text-xs border border-[#E2D9CC] px-1 py-0.5 bg-white" />
      <button onClick={add} disabled={busy} data-testid={`insights-add-${tid}`} className="inline-flex items-center gap-1 text-xs bg-[#3B1B48] text-[#FAF7F2] px-2.5 py-1.5 hover:bg-[#2A1334] disabled:opacity-60">
        <CalendarPlus className="w-3.5 h-3.5" />Add to build plan
      </button>
    </span>
  );
};
